var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './wrapper.scss';
import Icons from '../../../../icons';
import { ColumnFlexContainer, RightComponent, CenteredContainer } from '../../../../styles/generalStyles';
import BackButton from '../../../_common/button/back.button';
import { Button } from '../../../_common/button/button.styles';
import LangMessage from '../../../_common/lang/message';
import FormGadArt from '../../gadart';
import FormForgotPassword from '../forgot.password';
import FormGadArtLogin from '../gadart.login';
import FormLogin from "../login";
import FormRegistration from '../registration';
import SuccessScreen from '../success/success.reg';
import SuccessSendEmail from '../success/success.send.email';
var FormWrapper = function (_a) {
    var activeForm = _a.activeForm, handleFormChange = _a.handleFormChange, handleFormChangeAnimate = _a.handleFormChangeAnimate, animationClass = _a.animationClass, setActiveForm = _a.setActiveForm;
    var _b = useState('fadeIn'), animateOpacityClassLogin = _b[0], setAnimateOpacityLoginClass = _b[1];
    var _c = useState('fadeOut'), animateOpacityClassReg = _c[0], setAnimateOpacityRegClass = _c[1];
    var _d = useState(2), zIndexClassReg = _d[0], setZIndexClassReg = _d[1];
    var _e = useState('compressed'), stretchableContainerClass = _e[0], setStretchableContainerClass = _e[1];
    var navigate = useNavigate();
    useEffect(function () {
        var formClasses = {
            forgotPassword: "small",
            gadArt: 'small',
            gadArtLogin: 'small',
            login: 'compressed',
            registration: 'expanded',
            successScreen: 'long',
            successSendEmail: 'small'
        };
        setStretchableContainerClass(formClasses[activeForm] || 'small');
    }, [activeForm]);
    useEffect(function () {
        if (activeForm === 'registration') {
            setTimeout(function () { setAnimateOpacityRegClass && setAnimateOpacityRegClass('fadeIn'); }, 500);
            setTimeout(function () { setZIndexClassReg(12); }, 1000);
            navigate('/registration');
        }
        else {
            navigate('/login');
        }
    }, [activeForm, navigate]);
    var showFormRegistration = function () {
        if (activeForm === 'login') {
            setAnimateOpacityLoginClass('fadeOut');
            setTimeout(function () { return setStretchableContainerClass('expanded'); }, 10);
            setTimeout(function () {
                if (animateOpacityClassReg === 'fadeOut') {
                    setActiveForm && setActiveForm('registration');
                    setAnimateOpacityRegClass('fadeIn');
                    setTimeout(function () { return setZIndexClassReg(25); }, 10);
                }
            }, 300);
        }
    };
    var showFormLogin = function () {
        if (activeForm === 'registration') {
            setAnimateOpacityRegClass('fadeOut');
            setTimeout(function () {
                setActiveForm && setActiveForm('login');
            }, 100);
            setTimeout(function () {
                if (animateOpacityClassLogin === 'fadeOut') {
                    setAnimateOpacityLoginClass('fadeIn');
                    setZIndexClassReg(2);
                }
            }, 300);
        }
    };
    var showSuccessScreen = function () {
        if (animateOpacityClassReg === 'fadeIn' && stretchableContainerClass === 'expanded') {
            setAnimateOpacityRegClass('fadeOut');
            setTimeout(function () {
                setStretchableContainerClass('large');
                handleFormChange && handleFormChange('successScreen');
            });
            setTimeout(function () {
                setAnimateOpacityLoginClass('fadeIn');
            }, 300);
        }
    };
    var showSuccessAfterSendEmail = function () {
        handleFormChange && handleFormChange('successSendEmail');
    };
    var formHeaderLogo = activeForm === 'gadArtLogin' ? Icons.logoGad : Icons.logoGA24;
    var formComponents = {
        forgotPassword: _jsx(FormForgotPassword, { handleFormChangeAnimate: handleFormChangeAnimate, showSuccessAfterSendEmail: showSuccessAfterSendEmail }),
        gadArt: _jsx(FormGadArt, {}),
        gadArtLogin: _jsx(FormGadArtLogin, {}),
        login: _jsx(FormLogin, { handleFormChange: handleFormChange, handleFormChangeAnimate: handleFormChangeAnimate, showFormRegistration: showFormRegistration }),
        registration: _jsx(FormRegistration, { handleFormChange: handleFormChange, showSuccessScreen: showSuccessScreen }),
        successScreen: _jsx(SuccessScreen, { handleFormChangeAnimate: handleFormChangeAnimate }),
        successSendEmail: _jsx(SuccessSendEmail, { handleFormChangeAnimate: handleFormChangeAnimate })
    };
    var height100vhContainer = {
        display: 'flex',
        height: activeForm !== 'registration' ? '90vh' : '100%',
        justifyContent: 'flex-end',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: 6,
    };
    return (_jsx(RightComponent, __assign({ className: 'mainContainer' }, { children: _jsxs("div", __assign({ className: "formWrapper expandedMain" }, { children: [activeForm === 'registration' && _jsxs("div", __assign({ style: { zIndex: zIndexClassReg }, className: "fadeWrapper ".concat(animateOpacityClassReg) }, { children: [_jsx("div", __assign({ className: 'formWrapper__returnExpanded ' }, { children: _jsx(BackButton, { onClick: showFormLogin }) })), _jsx(CenteredContainer, { children: _jsx("img", { className: "formLogo", alt: "logo", src: Icons.logoGA24 }) }), _jsx("div", __assign({ className: "fadeWrapper ".concat(animationClass) }, { children: formComponents.registration }))] })), _jsxs("div", __assign({ style: height100vhContainer }, { children: [_jsxs("div", __assign({ className: "stretchableContainer ".concat(stretchableContainerClass) }, { children: [(activeForm === 'gadArtLogin' || activeForm === 'forgotPassword') && (_jsx("div", __assign({ className: 'formWrapper__return' }, { children: _jsx(BackButton, { onClick: function () { return handleFormChangeAnimate && handleFormChangeAnimate('login'); } }) }))), _jsxs("div", __assign({ className: "formWrapper fadeWrapper ".concat(animateOpacityClassLogin) }, { children: [_jsx("img", { className: "formLogo", alt: "logo", src: formHeaderLogo, style: activeForm === 'registration' ? { display: 'none' } : {} }), _jsx("div", __assign({ className: "fadeWrapper ".concat(animationClass) }, { children: activeForm !== 'registration' && formComponents && formComponents[activeForm] }))] }))] })), _jsx("div", __assign({ className: 'gadArtButtonWrapper' }, { children: activeForm === 'login' && (_jsx(ColumnFlexContainer, __assign({ className: 'gadArtButtonBlock' }, { children: _jsxs(Button, __assign({ "$size": 'big', "$borderColour": 'white', "$bgColour": 'transp', className: 'gadArtButton' // onClick={() => handleToGadArt()}>
                                    , onClick: function () { return handleFormChangeAnimate && handleFormChangeAnimate('gadArtLogin'); } }, { children: [_jsx(LangMessage, { msgKey: 'form.logToGadArt' }), _jsx("svg", __assign({ className: 'gadArtButton__arrow', width: "7", height: "12", viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M0.960754 11.2698L5.22968 6.00073L0.960754 0.73175", strokeWidth: "2" }) }))] })) }))) }))] }))] })) })));
};
export default FormWrapper;
